<template>
  <NodeViewWrapper
    class="internal-link-wrap inline align-bottom max-w-full ignore-editor-line-height"
  >
    <InternalLinkComponent
      v-bind="node.attrs"
      :key="getId()"
      :class="{ 'ProseMirror-selectednode': selected }"
      :editor-id="editor.id"
      @updateAttrs="updateAttrs"
    />
  </NodeViewWrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3';
import InternalLinkComponent from './InternalLink.vue';
import { getInternalLinkProps } from '@/utilities/internalLink';
import { nanoid } from 'nanoid';

export default {
  name: 'InternalLinkNode',

  components: {
    NodeViewWrapper,
    InternalLinkComponent,
  },

  props: nodeViewProps,

  mounted() {
    this.$nextTick(() => {
      // added this to update name attribute to nodes with link name (link name was hardcoded in extension)
      if (this.node.attrs.name === 'link') {
        const { name } = getInternalLinkProps(this.node.attrs['data-url']);
        this.updateAttributes({ name });
      }
    });
  },

  methods: {
    updateAttrs(newAttributes) {
      this.updateAttributes(newAttributes);
    },

    getId() {
      return nanoid(6);
    },
  },
};
</script>

<style lang="scss">
.internal-link-wrap {
  line-height: inherit !important;
}
</style>
